import { message } from "antd";
import axiosInstance from "../shared/axios";

// GET SESSIONS WITH PAGINATION + FILTERS
const getMedicineGroupAll = async (params) => {
  try {
    const result = await axiosInstance.get("/medicine-group/viewAll", {
      params: {
        name: params?.name,
        pageNo: params?.pageNo,
        recordsPerPage: params?.recordsPerPage,
      },
    });
    if (result?.status === 200 && result?.data?.success) {
      return {
        data: result?.data?.data || [],
        total: result?.data?.totalRecords || 0,
      };
    } else {
      message.error("Error while loading medicines group");
      return { data: [], total: 0 };
    }
  } catch (error) {
    message.error(
      error?.response?.data?.message || "Error while loading medicines group",
    );
    return { data: [], total: 0 };
  }
};

const addEditMedicinesGroup = async (payload, id) => {
  try {
    const result = await axiosInstance.post(
      id ? "/medicine-group/update" : "/medicine-group/create",
      { ...payload, id: id || null },
    );

    // Accept any 2xx status
    if (result?.status >= 200 && result?.status < 300) {
      return { success: true, data: result.data };
    } else {
      return { success: false };
    }
  } catch (error) {
    return {
      success: false,
      message:
        error?.response?.data?.message || "Failed to save medicines group",
    };
  }
};

const deleteMedicineGroup = async (id) => {
  try {
    const result = await axiosInstance.delete(`/medicine-group/delete/${id}`);

    if (result?.status >= 200 && result?.status < 300) {
      return { success: true };
    } else {
      return { success: false };
    }
  } catch (error) {
    return {
      success: false,
      message:
        error?.response?.data?.message || "Failed to delete medicines group",
    };
  }
};

const updateMedicineGroupStatus = async ({ id, IsActive }) => {
  try {
    let result = await axiosInstance?.post(`/medicine-group/updateStatus`, {
      id,
      IsActive: Boolean(IsActive),
    });

    if (result?.status === 200 && result?.data?.success) {
      return result?.data;
    } else {
      return {
        success: false,
        message:
          result?.data?.message || "Failed to update medicine group status",
      };
    }
  } catch (error) {
    return {
      success: false,
      message:
        error?.response?.data?.message ||
        error?.message ||
        "Failed to update medicine group status",
    };
  }
};

export const medicinegroup = {
  getMedicineGroupAll,
  addEditMedicinesGroup,
  deleteMedicineGroup,
  updateMedicineGroupStatus,
};
